import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../loader/Loader';
import { getAnimalAttachmentURL } from '../../services/animal.service';
import { Animal } from '../../types/interfaces/animal.interfaces';
import { ROUTE_PATHS } from '../../constants/routePaths';
import { ANIMAL_CONSTANTS, BUTTON_CONSTANTS, LABEL_CONSTANTS } from '../../constants/common';
import './animalListItem.scss';
import { filtersType, InventoryLocationState } from '../../pages/inventory/Inventory';
import { ViewMode } from '../../types/enums/viewMode.enum';

const AnimalListItem: FC<{
  animal: Animal;
  filterPreset?: filtersType;
  pagingOffset?: number;
  scrollY?: number;
  viewType?: ViewMode;
}> = ({ animal, filterPreset, pagingOffset, scrollY, viewType }): JSX.Element => {
  const navigate = useNavigate();

  const [imageLoading, setImageLoading] = useState<boolean>(true);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const onViewProfile = () => {
    const listState: InventoryLocationState = {
      filterPreset,
      scrollY,
      pagingOffset,
      viewType,
    };
    navigate(ROUTE_PATHS.APP_INVENTORY + '/' + animal.animalId, { state: listState });
  };

  useEffect(() => {
    if (animal.attachments && animal.attachments.length > 0) {
      const url = getAnimalAttachmentURL(animal.animalId!, animal.attachments[0].attachmentId, animal.attachments[0].accessToken);
      setImageUrl(url);
    }
  }, [animal]);

  return (
    <div className="animal-list-item">
      <div className="animal-list-image">
        {imageUrl ? (
          <div className="image-container">
            {imageLoading && (
              <div className="image-loader-container">
                <Loader loaderSize={'small'} />
              </div>
            )}
            <img
              src={imageUrl}
              alt="Animal Image"
              onLoad={() => setImageLoading(false)}
              onError={() => setImageLoading(false)}
              style={{ display: imageLoading ? 'none' : 'block' }}
            />
          </div>
        ) : (
          <div className="animal-image-placeholder">
            <span>{ANIMAL_CONSTANTS.NO_IMAGE}</span>
          </div>
        )}
      </div>
      <div className="animal-list-content">
        <div className="animal-list-main-info">
          <h3>{animal.name}</h3>
          <div className="animal-list-details">
            <div className="detail-item">
              <span className="label">{ANIMAL_CONSTANTS.SIRE}:</span>
              <span className="value">{animal.sire ?? '--'}</span>
            </div>
            <div className="detail-item">
              <span className="label">{ANIMAL_CONSTANTS.DAM}:</span>
              <span className="value">{animal.dam ?? '--'}</span>
            </div>
            <div className="detail-item">
              <span className="label">{ANIMAL_CONSTANTS.DNA}:</span>
              <span className="value">{animal.dna ?? '--'}</span>
            </div>
            <div className="detail-item">
              <span className="label">{LABEL_CONSTANTS.UNITS_OWNED}:</span>
              <span className="value units">{animal?.quantityOwned ?? '--'}</span>
            </div>
          </div>
        </div>
        <div className="animal-list-action">
          <button className="button green medium" type="button" onClick={onViewProfile}>
            {BUTTON_CONSTANTS.VIEW_PROFILE}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnimalListItem;
